module.exports = __webpack_public_path__ + "img/IV-encuentros-internacionales-sector-TIC.aae7293d.jpg";